'use strict';

/**
 * @author Maxim Seredkin
 */
import angular from 'angular';

export default ['$scope', '$routeParams', '$log', '$uibModalInstance', '$uibModal', 'workPlace', 'QuarterRestService', 'edit', 'workPlaces',
                function($scope, $routeParams, $log, $modalInstance, $modal, workPlace, QuarterRestService, edit, workPlaces) {
                    $scope.ok = ok;
                    $scope.cancel = cancel;
                    $scope.edit = edit;
                    $scope.isUniqueWorkPlace = isUniqueWorkPlace;

                    $scope.workPlace = angular.copy(workPlace);
                    $scope.workPlaces = angular.copy(workPlaces);

                    if (!angular.equals(workPlace, {})) {
                        $scope.workPlaces.splice(workPlaces.indexOf(workPlace), 1);
                    }

                    QuarterRestService.tree(null, (data) => {
                        $scope.quarters = data._embedded;

                        if (workPlace.quarter == null) return;

                        $scope.year = $scope.quarters[workPlace.quarter.year];

                        if (!($scope.year != null && Array.isArray($scope.year))) return;

                        $scope.workPlace.quarter = $scope.year.find((quarter) => quarter.id === workPlace.quarter.id);
                    });

                    // region Function

                    function ok() {
                        $modalInstance.close($scope.workPlace);
                    }

                    function cancel() {
                        $modalInstance.dismiss();
                    }

                    function isUniqueWorkPlace() {
                        return !$scope.workPlaces.some((tx) => {
                            return equalsId(tx.quarter, $scope.workPlace.quarter);
                        });
                    }

                    function equalsId(obj1, obj2) {
                        if (!obj1) return false;
                        if (!obj2) return false;

                        return obj1.id === obj2.id;
                    }

                    // endregion
                }];
